export { default as StrategyReferralInfo } from './StrategyReferralInfo';
